const buttonStyle = {
  fontFamily: 'Schibsted Grotesk',
  color: 'gray',
  fontSize: '.9rem',
  fontWeight: 500,
  textTransform: 'none',
  borderRadius: '6px 0px 0px 0px',
  height: '52px',
  '& .MuiButtonBase-root-MuiButton-root:hover': {
    color: '#00CECF',
  },
};

export default buttonStyle;